import { parseMfbParts } from "../../../utils/mfbUtils";

export default function getAuthoringPreviewProps(
  item,
  typeToColorMap = {},
  previewMarkup = {},
  setPreviewMarkup = () => {},
  previewSelectedColor = null,
  setPreviewSelectedColor = () => {},
  previewOrder = []
) {
  const isMatch = item?.Type === "Match";
  const isRearrange = item?.Type === "ReArrange";

  const matchOptionsArray = Array.isArray(item?.Options) ? item.Options : [];

  const rearrangeWords = isRearrange
    ? (item?.Options?.[0]?.Value || "").split(" ").filter((w) => w.trim())
    : [];

  const rankingPreview = Array.isArray(item?.Options)
    ? item.Options.map((o, index) => ({
        Id: index + 1,
        Value: o.Value,
        Rationale: { Text: o.Rationale },
      }))
    : [];

  return {
    activity: {
      ...item,
      ContentId: "preview",
    },

    index: 0,
    total: 1,
    submitted: false,
    preview: true,

    // MCMA
    answers: {},
    handleOptionChange: () => {},

    // MATCH
    matchSelections: {},
    shuffledNames: isMatch ? matchOptionsArray.map((o) => o.Name) : [],
    shuffledValues: isMatch ? matchOptionsArray.map((o) => o.Value) : [],
    handleSelectChange: () => {},

    // MFB
    mfbSelections: {},
    shuffledMfbOptions: [],

    // MARKUP — this is the important part
    markupAnswers: previewMarkup,
    setMarkupAnswers: setPreviewMarkup,
    typeToColorMap,
    selectedColor: previewSelectedColor,
    setSelectedColor: setPreviewSelectedColor,

    // REARRANGE
    rearrangeSelections: {},
    shuffledWords: previewOrder.length ? previewOrder : rearrangeWords,

    setShuffledWords: () => {},

    // RANKING
    rankingSelections: rankingPreview,
    setRankingSelections: () => {},

    // IRAAB
    iraabAnswers: {},
    selectedIraabWord: null,
    setIraabAnswers: () => {},
    setSelectedIraabWord: () => {},

    reviewedContent: {},
    setReviewedContent: () => {},
  };
}
